import React, { useEffect, useState } from "react";
import { SlideOne } from "./components/SlideOnePyme";
import { SlideTwo } from "./components/SlideTwoPyme";
import { SlideThree } from "./components/SlideThreePyme";
import { FormProvider, useForm } from "react-hook-form";
import { SlideFour } from "./components/SlideFourPyme";
import { SlideFive } from "./components/SlideFivePyme";
import Swal from "sweetalert2";
import axios from "axios";
// import { Card, Col, Container, Form, Row } from './react-bootstrap';

const baseUrl = process.env.REACT_APP_API_URL
const procotol = process.env.REACT_APP_API_PROTOCOL

export const RegisterRequestPyme = () => {
  document.title = "CENEC | Registro de Solicitud PYME";

  const methods = useForm();
  const { handleSubmit, setValue, getValues, formState: { errors } } = methods;
  const [formData, setFormData] = useState({}); // Estado global para almacenar los datos de todos los slides
  const [currentSlide, setCurrentSlide] = useState(0); // Slide actual
  const [isSubmitting, setIsSubmitting] = useState(false);

  const slides = [
    <SlideOne setValue={setValue} getValues={getValues} errors={errors} formData={formData} setFormData={setFormData} />,
    <SlideTwo setValue={setValue} getValues={getValues} errors={errors} formData={formData} setFormData={setFormData} />,
    <SlideThree setValue={setValue} getValues={getValues} errors={errors} formData={formData} setFormData={setFormData} />,
    <SlideFour setValue={setValue} getValues={getValues} errors={errors} formData={formData} setFormData={setFormData} />,
    <SlideFive setValue={setValue} getValues={getValues} errors={errors} formData={formData} setFormData={setFormData} />,
  ];

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const urlStartTransc = `${procotol}//${baseUrl}/administration/api/register-request/`;

    const formDataToSend = new FormData();

    Object.keys(formData).forEach((key) => {
      // Excluye el campo "signatureBase64" antes de procesar
      if (key === "signatureBase64") return;

      const value = formData[key];
      if (value instanceof FileList) {
          // Si es un FileList, agrega solo el primer archivo
          if (value.length > 0) {
              formDataToSend.append(key, value[0]);
          }
      } else if (value instanceof File) {
          // Si es un archivo File, agrégarlo directamente
          formDataToSend.append(key, value);
      } else {
          // Agrega otros datos tal cual
          formDataToSend.append(key, value);
      }
    });

    formDataToSend.append("request_type", "Pyme");

    try {
        const response = await axios.post(urlStartTransc, formDataToSend);

        if (response.status === 201) {
            Swal.fire({
                title: '¡Registro exitoso!',
                text: 'Tu solicitud se ha registrado correctamente.',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            }).then(() => {
                window.location.reload();
            });
        } else {

            Swal.fire({
                title: 'Algo no salió bien!',
                text: response.data.message || 'Hubo un error al procesar tu solicitud.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
            });
        }
    } catch (error) {
        Swal.fire({
            title: 'Error de conexión',
            text: 'No se pudo conectar con el servidor. Por favor, intenta de nuevo.',
            icon: 'error',
            confirmButtonText: 'Aceptar'
        });
    }finally {
      setIsSubmitting(false);
    }
  };

  const nextSlide = () => {
    handleSubmit((data) => {
      // Combina los datos actuales con los datos previos en formData
      setFormData((prevData) => ({ ...prevData, ...data }));

      if (currentSlide === 2 && data.accept_terms === "N") {
        Swal.fire({
          title: 'No puedes avanzar',
          text: 'Debes aceptar los términos del contrato para continuar.',
          icon: 'warning',
          confirmButtonText: 'Aceptar',
        });
        return; // Detiene el avance si no se aceptan los términos
      }

      // Avanza al siguiente slide si no es el último
      if (currentSlide < slides.length - 1) {
        setCurrentSlide(currentSlide + 1);
      } else {
        onSubmit({ ...formData, ...data });
      }
    })();
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1); // Regresa al slide anterior
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="">
          {slides[currentSlide]}
      </div>
      <div className="d-flex justify-content-end mt-3" style={{ maxWidth: '97%', margin: '0 auto' }}>
          <button
              className="btn btn-cenec me-2"
              onClick={prevSlide}
              disabled={currentSlide === 0}
          >
              Anterior
          </button>
          {currentSlide === slides.length - 1 ? (
              <button
                className="btn btn-cenec"
                onClick={handleSubmit(onSubmit)}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Enviando..." : "Enviar"}
              </button>
          ) : (
              <button className="btn btn-cenec" onClick={nextSlide}>
                  Siguiente
              </button>
          )}
      </div>
    </FormProvider>
  );
};
